import { useCallback } from 'react';
import { ObjectRelationSettings } from '@/features/image-rendering/components/object-relation-settings';

import type { ImageToVideoModel } from '../../hooks/useImageToVideoActions';
import ModeSection from './sections/modeSection';
import SettingsSection from './sections/settingsSection';
import SourceSection from './sections/sourceSection';

export type MainSidebarProps = {
  model: ImageToVideoModel;
  initialEstateId?: string | null;
  initialProjectId?: string | null;
  disableSelectObject: boolean;
};

export const MainSidebar = ({
  model,
  initialEstateId,
  initialProjectId,
  disableSelectObject,
}: MainSidebarProps) => {
  const {
    style: { estateId, projectId },
    actions,
  } = model;

  const effectiveEstateId = disableSelectObject
    ? (initialEstateId ?? undefined)
    : (estateId ?? initialEstateId ?? undefined);

  const effectiveProjectId = disableSelectObject
    ? (initialProjectId ?? undefined)
    : (projectId ?? initialProjectId ?? undefined);

  const handleEstateIdChange: React.Dispatch<React.SetStateAction<string | undefined>> =
    useCallback(
      (valueOrUpdater) => {
        const previous = effectiveEstateId;
        const next =
          typeof valueOrUpdater === 'function'
            ? valueOrUpdater(previous)
            : (valueOrUpdater ?? undefined);
        actions.onEstateChange(next ?? null);
      },
      [actions, effectiveEstateId]
    );

  const handleProjectIdChange = useCallback(
    (next?: string) => {
      actions.onProjectChange(next ?? null);
    },
    [actions]
  );

  return (
    <div className="space-y-3">
      <SourceSection model={model} />
      <ObjectRelationSettings
        estateId={effectiveEstateId}
        projectId={effectiveProjectId}
        onChangeEstateId={handleEstateIdChange}
        onChangeProjectId={handleProjectIdChange}
        disableSelectObject={disableSelectObject}
      />
      <ModeSection model={model} />
      <SettingsSection model={model} />
    </div>
  );
};
